export const bitmapAdapterExtensions = [".jpg", ".jpeg"]
